import {NgxFilterConfig} from "./ngx-filter-config";
import {InjectionToken} from "@angular/core";

export const NGX_FILTERS_CONFIGS = new InjectionToken<NgxFilterConfig>('NGX_FILTERS_CONFIGS');

